import { Outlet } from "react-router-dom";

const FormConfigurationLayout = () => {
  return (
    <div className="h-full w-full overflow-hidden p-2">
      <Outlet />
    </div>
  );
};

export default FormConfigurationLayout;
